import React from 'react'

const Subadmin = () => {
  return (
    <div>Subadmin</div>
  )
}

export default Subadmin